import { InternalMessageType } from '../../enums';
import { InternalMessagePayloadValidator } from '../../types';
import { InternalGalleryReadyPayload } from './types';

export const internalGalleryReadyPayloadValidator: InternalMessagePayloadValidator<
  InternalMessageType.GalleryReady
> = (payload: unknown): payload is InternalGalleryReadyPayload =>
  !!payload &&
  typeof payload === 'object' &&
  'value' in payload &&
  typeof payload.value === 'boolean';
